import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IFundraiser } from '../../fundraiser/models/fundraiser.model';
import { EventsService, PortfolioService, StorageService, UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-story-popup',
  templateUrl: './story-popup.component.html',
  styleUrls: ['./story-popup.component.scss']
})
export class StoryPopupComponent implements OnInit {

  @Input() fundraiser: IFundraiser;
  isMobile: any;
  @ViewChild('storypopup', { static: true }) storypopup: TemplateRef<any>;
  lastDonor;

  constructor(
    public utilService: UtilService,
    public dialog: MatDialog,
    public portfolioService: PortfolioService,
    public storageService: StorageService,
    public eventService: EventsService,
    public vars: VariablesService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.utilService.isMobile();
    setTimeout(() => {
      if (!this.vars.clickedAnywhere) {
        this.openDialog(this.storypopup);
      }
    }, 20000);
  }

  openDialog(template) {
    const popup: any = document.getElementById('full-payment-wrapper');
    if (!popup) {
      this.dialog.open(template, {
        width: this.utilService.isMobile() ? '100%' : '',
        maxWidth: '590px',
        maxHeight: '98vh',
        panelClass: 'popup-dialog',
        disableClose: true,
      });
    }
    if (!this.utilService.isMobile()) {
      document.body.classList.toggle('noscroll', true);
    }
    const payload = {};
    this.portfolioService.getTickrData(payload).subscribe(async (res: any) => {
      this.lastDonor = res?.data[Math.floor(Math.random() * 10)];
    });
  }

  close() {
    this.dialog.closeAll();
    if (!this.utilService.isMobile()) {
      document.body.classList.toggle('noscroll', false);
    }
  }

  scroll() {
    this.close();
    setTimeout(() => {
      this.utilService.scrollIntoViewSmoothlyByClass('tnc', 0, -140);
    }, 200);
    this.sendSystemEvent();
  }

  sendSystemEvent() {
    const payload = {
      eventName: 'donatepopup_clicked'
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
  }

}
